import { useRef } from "react";
import { Center } from "@react-three/drei";
import Island from "./Island";
import Clickables from "./Clickables";

export default function Experience() {
  const centerRef = useRef();

  return (
    <>
      <color args={["#040f16"]} attach="background" />
      <Center position-y={-8} ref={centerRef}>
        <Clickables center={centerRef} />
        <Island />
      </Center>
    </>
  );
}
